// extracted by mini-css-extract-plugin
module.exports = {"table":"PayrollRuleInfo__table--36RWR"};